/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'delete': {
    width: 26,
    height: 26,
    viewBox: '0 0 26 26',
    data: '<g _fill="#FF7F92" fill-rule="evenodd"><path pid="0" d="M13 23.598c-5.844 0-10.6-4.755-10.6-10.6s4.756-10.6 10.6-10.6c5.845 0 10.6 4.755 10.6 10.6s-4.755 10.6-10.6 10.6zM13 .462C6.088.462.464 6.086.464 12.998c0 6.913 5.624 12.536 12.536 12.536s12.536-5.623 12.536-12.536C25.536 6.086 19.912.462 13 .462z"/><path pid="1" d="M17.824 8.174a.966.966 0 00-1.365 0L13 11.633l-3.459-3.46A.966.966 0 008.176 9.54L11.634 13l-3.458 3.458a.966.966 0 001.365 1.365L13 14.364l3.459 3.458a.962.962 0 001.365 0 .966.966 0 000-1.365l-3.459-3.459 3.46-3.459a.966.966 0 000-1.365"/></g>'
  }
})
